var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVibra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 30,
    viewBox: "0 0 84 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96341 6.82927H0V23.1707H4.93902C4.93902 23.1707 13.9534 0.978415 14.3293 0.97561C14.6455 0.973171 8.23171 30 8.23171 30H15.7927C15.7927 30 24.2417 9.59854 24.5732 9.5122C25.1252 9.36841 22.9878 23.1707 22.9878 23.1707H26.7683L26.8902 6.82927H21.8902C21.8902 6.82927 12.6639 29.1009 12.5 29.0244C12.0576 28.8182 18.4756 0 18.4756 0H11.0366C11.0366 0 2.57659 20.2937 2.13415 20.7317C1.79598 21.0665 3.96341 6.82927 3.96341 6.82927Z",
    fill: "#0E7716"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8413 6.82922H34.9388V23.0487H39.8169L46.7681 6.82922H42.8657L37.012 20.6097L38.8413 6.82922Z",
    fill: "#0E7716"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3903 23.1097H83.2927V6.89023H78.4147L71.4635 23.1097H75.3659L81.2196 9.32925L79.3903 23.1097Z",
    fill: "#0E7716"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1584 6.82922L47.7437 23.0487H43.9633L47.3779 6.82922H51.1584Z",
    fill: "#0E7716"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3294 6.82922L60.9148 23.0487H64.6953L66.2806 16.2195L67.4499 16.2123C68.1506 16.2024 68.553 16.8204 68.4758 17.317C68.2605 18.7003 67.4743 22.107 67.6221 23.0487C67.6224 23.0491 71.2806 23.0642 71.2806 23.0642C71.2621 22.2051 71.8837 18.7511 72.1343 17.439C72.3448 16.3368 71.4932 14.7304 70.0638 14.7689C69.9891 14.7709 69.9924 14.6073 70.0671 14.6037C71.5655 14.5324 73.9086 12.6872 73.8416 10.1219C73.8054 8.73227 72.4266 6.87886 69.2075 6.82922H64.3294ZM67.6686 9.44691L66.7866 13.3715L68.1276 13.3395C69.1311 13.023 69.7847 12.1687 69.9839 11.2718C70.1185 10.6659 69.8997 9.99362 69.293 9.65484C69.1115 9.55349 68.9109 9.47666 68.7054 9.42215L67.6686 9.44691Z",
    fill: "#0E7716"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8659 6.8293L49.4513 23.0488H54.5732C58.395 23.2964 60.843 20.5272 60.6708 17.683C60.5695 16.0089 59.3618 14.9633 58.2151 14.8215C58.1529 14.8137 58.0809 14.7175 58.2318 14.6952C58.352 14.6774 61.9457 13.7915 62.0123 10.3659C62.0835 6.69955 57.744 6.8293 57.744 6.8293H52.8659ZM54.6952 16.0976L53.7196 20.4878H55.061C56.0718 20.1589 56.7456 19.2158 56.9662 18.2124C57.1152 17.5344 56.9126 16.7725 56.3141 16.3752C56.1351 16.2564 55.9364 16.1645 55.7323 16.0976H54.6952ZM56.1758 9.40308L55.2937 13.3277L56.6348 13.2956C57.6384 12.9792 58.2919 12.125 58.4912 11.228C58.6257 10.6221 58.4069 9.94979 57.8002 9.61113C57.6186 9.50979 57.4181 9.43296 57.2125 9.37833L56.1758 9.40308Z",
    fill: "#0E7716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVibra);
export default __webpack_public_path__ + "static/media/logo-vibra.6b4fc21c3260b22f4a957cd9fffcacb3.svg";
export { ForwardRef as ReactComponent };